import styled from 'styled-components';

// 1rem === 1px here — src/App.scss sets html { font-size: 0.0625rem }.

// The art is a base64 PNG wrapped in an SVG, intrinsically 973x631. Every cap
// below derives from these two numbers, so re-exporting the asset at a new size
// only needs this one edit.
//
// Note the ratio is ≈1.542, deliberately NOT the "approximately 16:9" the
// ticket text asks for — that describes the OUTGOING asset (1678x937 ≈ 1.791).
// Forcing 16/9 on this art would stretch it.
const NATIVE_IMAGE_DIMENSIONS = { width: 973, height: 631 };

// Rendering the art wider than its native width upscales the raster and visibly
// softens it, which the ticket explicitly forbids ("preserve image quality").
// This cap is a quality constraint, not a style preference.
const NATIVE_IMAGE_WIDTH = `${NATIVE_IMAGE_DIMENSIONS.width}rem`;

const NATIVE_IMAGE_ASPECT_RATIO = `${NATIVE_IMAGE_DIMENSIONS.width} / ${NATIVE_IMAGE_DIMENSIONS.height}`;

// The same ratio as a bare multiplier, for the width-expressed height cap below.
const NATIVE_IMAGE_RATIO =
  NATIVE_IMAGE_DIMENSIONS.width / NATIVE_IMAGE_DIMENSIONS.height;

// Vertical space already spoken for above and below the hero on the Store page:
//   139rem header (72rem logo + 67rem nav, see Layout.styles.ts)
// + 130rem main padding-block (30rem top / 100rem bottom)
// + ~50rem for the "next step" button row that floats above the content
// Capping by the remainder keeps the hero fully visible without a scrollbar on
// short laptop screens. It no longer has to account for the ZIP search block,
// which now sits beside the hero rather than above it.
const RESERVED_VERTICAL_SPACE = '320rem';

export const Container = styled.div({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

export const Image = styled.img({
  // The art is ~1.54:1 (973x631), NOT the 16:9 the ticket text claims — that
  // describes the outgoing asset. Pinning its real ratio keeps the box honest.
  aspectRatio: NATIVE_IMAGE_ASPECT_RATIO,
  width: '100%',
  height: 'auto',
  // Both caps are expressed as WIDTHS so a short viewport shrinks the box on
  // both axes instead of squashing it. A bare `maxHeight` loses to `width:
  // 100%` (an explicit width plus a binding max-height both outrank
  // aspect-ratio), which stretched the raster to 2.096 at 1024x768.
  maxWidth: `min(${NATIVE_IMAGE_WIDTH}, calc((100vh - ${RESERVED_VERTICAL_SPACE}) * ${NATIVE_IMAGE_RATIO}))`,
  display: 'block',
  borderRadius: '8rem',
});
